<template lang="pug">
  .msg-data__input
    Select(
      :value="periodText"
      :selectData="periodsList"
      @params="choosenPeriod"
    )
</template>

<script>
import moment from 'moment';
import Select from './Select';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: { Select },
  props: {
    value: {}
  },
  data() {
    return {
      startPeriod: '2010-09-01',
      startYear: 2010,
      periods: [],
      periodText: ''
    };
  },
  computed: {
    period() {
      return this.$route.query.period;
    },
    year() {
      return this.$route.query.year;
    },
    groupIds() {
      return this.$route.query.groupIds ? this.$route.query.groupIds : '';
    }
  },
  watch: {
    period() {
      if (this.period && this.year) {
        if (this.period == 1) {
          this.periodText = `Сент ${this.year} - Февр ${+this.year + 1}`;
        } else {
          this.periodText = `Март ${+this.year + 1} - Авг ${+this.year + 1}`;
        }
      }
    },
    year() {
      if (this.period && this.year) {
        if (this.period == 1) {
          this.periodText = `Сент ${this.year} - Февр ${+this.year + 1}`;
        } else {
          this.periodText = `Март ${+this.year + 1} - Авг ${+this.year + 1}`;
        }
      }
    }
  },
  mounted() {
    if (this.period && this.year) {
      if (this.period == 1) {
        this.periodText = `Сент ${this.year} - Февр ${+this.year + 1}`;
      } else {
        this.periodText = `Март ${+this.year + 1} - Авг ${+this.year + 1}`;
      }
    }
  },
  methods: {
    choosenPeriod(value) {
      replaceRouteQuery([
        {
          name: 'year',
          value: value.year,
          method: 'replace'
        },
        {
          name: 'period',
          value: value.period,
          method: 'replace'
        },
        {
          name: 'groupIds',
          value: this.groupIds,
          method: 'replace'
        }
      ]);
    },
    periodsList() {
      const arr = [];
      const yearsBetween = moment().diff(this.startPeriod, 'years') * 2 + 1;
      for (let i = 1; i <= yearsBetween; i++) {
        const obj = { period: 1, year: this.startYear };
        if (i % 2 === 0) {
          obj.period = 2;
          obj.text = `Март ${obj.year + 1} - Авг ${obj.year + 1}`;
          this.startYear += 1;
        } else {
          obj.year = this.startYear;
          obj.text = `Сент ${obj.year} - Февр ${obj.year + 1}`;
        }

        arr.push(obj);
      }

      return arr.reverse();
    }
  }
};
</script>
